import React from 'react';
import Hero from '../components/Hero'
import Carousel from '../components/Carousel'
import './Homepage.scss'

function HomePage(props) {
    return (
        <div className="home-page">
            <Hero title={props.title} subtitle={props.subtitle} content={props.content} home={true} />
            <Carousel />
        </div>
    );
}

export default HomePage;